<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Cron execution
        </h6>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">
          Cron execution list
        </h5>

        <Search
            class="mb-3"
            :filters="filters"
            :loading="isSearching"
            :lastAttemptSuccessDropdown="lastAttemptSuccessDropdown"
            @search="getCronList"/>

        <PerPage :values="[10, 25, 50, 100]" @update:perPage="getCronList"/>

        <div class="table-responsive overflow-auto pt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Command name</th>
              <th>Cron expression</th>
              <th>Last Run at</th>
              <th>Last attempt at</th>
              <th>Success</th>
              <th>Info</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(cron) in cronList.data" :key="cron.id">
              <td>{{ cron?.commandName }}</td>
              <td>{{ cron?.cronExpression }}</td>
              <td>{{ cron?.lastRunAt }}</td>
              <td>{{ cron?.lastAttemptAt }}</td>
              <td>
                <div class="ps-3">
                  <div v-if="cron?.lastAttemptSuccess"
                       class="status-pill green p-2 me-2"
                       data-bs-toggle="tooltip"
                       data-original-title=""
                       title="">
                  </div>
                  <div v-else
                       class="status-pill red p-2 me-2"
                       data-bs-toggle="tooltip"
                       data-original-title=""
                       title="">
                  </div>
                </div>
              </td>
              <td>{{ cron?.info }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="cronList?.pagination?.total_pages > 1"
            :totalPages="cronList?.pagination?.total_pages"
            :currentPage="cronList?.pagination?.current_page"
            :totalItems="cronList?.pagination?.total_items"
            :perPage="cronList?.pagination?.items_per_page"
            @pagechanged="getCronList"/>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup>
import systemMonitoringService from '@/api/SystemMonitoring';
import Pagination from '@/components/Pagination.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import PerPage from '@/components/PerPage.vue';
import {onMounted, ref} from 'vue';
import Search from "@/views/App/SystemMonitoring/CronExecution/Search.vue";

const cronList = ref([]);
const isSearching = ref(false);
const isLoaded = ref(false);

const filters = ref({
  lastAttemptSuccess: '',
  personio: false
});

const lastAttemptSuccessDropdown = ref([
  {
    value: 'true',
    label: 'Success',
  },
  {
    value: 'false',
    label: 'Failed',
  }
])

async function getCronList(page = 1, perPage, passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = cronList.value?.pagination?.items_per_page;

  try {
    const {data} = await systemMonitoringService.getCronExecutions({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    cronList.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  await getCronList()
  isLoaded.value = true;
});

</script>

<style scoped>

</style>